import { render, staticRenderFns } from "./MediaLeftAlign.vue?vue&type=template&id=3ef476a2&"
import script from "./MediaLeftAlign.vue?vue&type=script&lang=js&"
export * from "./MediaLeftAlign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports